import React, { useState } from "react";
import {
  Button,
  Dialog,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Input,
  Checkbox,
  Select,
  Option,
} from "@material-tailwind/react";
import { canadianProvinces } from "../../utils/constants";
import { isValidEmail, isValidPassword } from "../../utils/helpers";
import { AlertCustomStyles } from "../layout/AlertCustomStyles";
import UserService from "../../services/user.service";
import { SpinnerWithInfo } from "../layout/SpinnerWithInfo";
export default function PasswordInfoEditorForm({ loggedInUser, onComplete }) {
  const [error, setError] = useState("");
  const [alert, setAlert] = useState("");
  const [loading, setLoading] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const handleSubmit = () => {
    if (
      error ||
      !oldPassword ||
      !isValidPassword(oldPassword) ||
      !newPassword ||
      !isValidPassword(newPassword)
    ) {
      setAlert("NotComplete");
    } else {
      setAlert("");
      setLoading(true);
      UserService.updateUserDetails({
        oldPassword: oldPassword,
        newPassword: newPassword,
        id: loggedInUser.id,
        email: loggedInUser.email,
      }).then(
        (res) => {
          setLoading(false);
          onComplete({ type: "Password", result: "success" });
        },
        (error) => {
          setLoading(false);
          onComplete({ type: "Password", result: "fail" });
        }
      );
    }
  };
  return (
    <>
      <Card className="mx-auto w-full max-w-[24rem] md:p-2">
        {!loading && (
          <>
            <CardBody className="flex flex-col gap-6">
              {alert && alert == "fail" && (
                <AlertCustomStyles
                  status={alert}
                  message={"Updating address failed, try again!"}
                />
              )}
              {alert && alert == "NotComplete" && (
                <AlertCustomStyles
                  status={alert}
                  message={"Invalid password, try again!"}
                />
              )}
              <Typography
                className="mb-1 font-normal font-nunito"
                variant="paragraph"
                color="gray"
              >
                Change Password
              </Typography>
              <Input
                name="oldPassword"
                label="Old Password (at least 8 characters)"
                onChange={(e) => setOldPassword(e.target.value)}
                error={error}
                value={oldPassword}
                type="password"
              />
              <Input
                name="newPassword"
                label="New Password (at least 8 characters)"
                onChange={(e) => setNewPassword(e.target.value)}
                error={error}
                value={newPassword}
                type="password"
              />
            </CardBody>
            <CardFooter className="pt-0 flex gap-3 m-auto">
              <Button
                variant="button"
                className=" bg-[#882699] hover:bg-[#cf3be9] normal-case md:text-[15px] text-[12px]"
                onClick={handleSubmit}
                size="sm"
              >
                Update
              </Button>
              <Button
                variant="outlined"
                color="red"
                onClick={() => onComplete({ type: "Password", result: null })}
                size="sm"
                className="normal-case md:text-[15px] text-[12px]"
              >
                <span>Cancel</span>
              </Button>
            </CardFooter>
          </>
        )}
        {loading && (
          <div className="p-20">
            <SpinnerWithInfo message="Saving changes..." />
          </div>
        )}
      </Card>
    </>
  );
}
